/**
 * Simulação de P&L por tipo de gale — espelho de
 * autoblaze-api/app/Services/GaleStakePreview.php e
 * autoblaze_seed/src/engine/martingale.js.
 *
 * A escada não usa o auto-retirar. min_result entra só no crédito da mão
 * vencedora. Apostas em reais inteiros (ceil). Entrada de referência R$ 2.
 */

export const PREVIEW_BASE = 2
export const PREVIEW_STEPS = 4
export const MIN_BET = 2

export const TYPE_META = [
  { id: 'martingale', label: 'Martingale', short: 'Mart.' },
  { id: 'linear', label: 'Linear', short: 'Lin.' },
  { id: 'flat', label: 'Fixo', short: 'Fixo' },
  { id: 'soros', label: 'Soros', short: 'Soros' },
  { id: 'soros_gale', label: 'Soros gale', short: 'SG' },
]

const TYPE_IDS = TYPE_META.map((row) => row.id)

export function roundUpReais(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || n <= 0) return 0
  return Math.ceil(n)
}

export function normalizeGaleType(value) {
  const type = String(value || '').toLowerCase().trim()
  if (type === 'soros_recovery') return 'soros_gale'
  return TYPE_IDS.indexOf(type) >= 0 ? type : 'martingale'
}

export function galeTypeLabel(value) {
  const id = normalizeGaleType(value)
  const hit = TYPE_META.find((row) => row.id === id)
  return hit ? hit.label : 'Martingale'
}

export function galeTypeShort(value) {
  const id = normalizeGaleType(value)
  const hit = TYPE_META.find((row) => row.id === id)
  return hit ? hit.short : 'Mart.'
}

export function formatSignedReais(value) {
  const n = Math.round(Number(value) || 0)
  if (n > 0) return `+${n}`
  return String(n)
}

export function stakeForAttempt({ type, attempt, base, accumulatedLoss }) {
  const n = Math.max(1, Math.floor(Number(attempt) || 1))
  const entry = roundUpReais(base)
  const kind = normalizeGaleType(type)

  if (kind === 'soros_gale') {
    if (Number(accumulatedLoss) > 0) {
      return Math.max(roundUpReais(Number(accumulatedLoss) / 2 + entry), MIN_BET)
    }
    return entry
  }

  if (n <= 1) return entry
  if (kind === 'flat' || kind === 'soros') return entry
  if (kind === 'linear') return roundUpReais(entry * n)
  return roundUpReais(entry * 2 ** (n - 1))
}

function previewOne(meta, crashValues, minResult, base, steps) {
  let acc = 0
  const stakes = []
  const limit = Math.min(steps, crashValues.length)

  for (let i = 0; i < limit; i += 1) {
    const attempt = i + 1
    const stake = stakeForAttempt({
      type: meta.id,
      attempt,
      base,
      accumulatedLoss: acc,
    })
    stakes.push(stake)
    if (Number(crashValues[i]) >= minResult) {
      const pnl = Math.round(stake * (minResult - 1) - acc)
      return {
        type: meta.id,
        label: meta.label,
        short: meta.short,
        stakes,
        won: true,
        position: attempt,
        pnl,
        carries: false,
        carried_loss: 0,
      }
    }
    acc += stake
  }

  const carries = meta.id === 'soros_gale' && acc > 0
  return {
    type: meta.id,
    label: meta.label,
    short: meta.short,
    stakes,
    won: false,
    position: null,
    pnl: -acc,
    carries,
    carried_loss: carries ? acc : 0,
  }
}

export function previewAll(crashValues, minResult, base = PREVIEW_BASE, steps = PREVIEW_STEPS) {
  let factor = Number(minResult)
  if (!Number.isFinite(factor) || factor <= 1) factor = 2
  const entry = roundUpReais(base) || PREVIEW_BASE
  const max = Math.max(1, Math.floor(Number(steps) || PREVIEW_STEPS))
  const crashes = Array.isArray(crashValues) ? crashValues : []
  return TYPE_META.map((meta) => previewOne(meta, crashes, factor, entry, max))
}

export function crashesFromAround(around) {
  return (Array.isArray(around) ? around : [])
    .filter((row) => Number(row && row.position) >= 1)
    .sort((a, b) => Number(a.position) - Number(b.position))
    .map((row) => Number(row.value))
}

export function typeResultsForSignal(signal, minResult) {
  if (Array.isArray(signal && signal.type_results) && signal.type_results.length) {
    return signal.type_results
  }
  const outcome = signal && signal.outcome
  if (outcome !== 'Sucesso' && outcome !== 'Falha') return []
  return previewAll(crashesFromAround(signal.around_results), minResult)
}
